<template>
    <div class="space-y-8 sm:space-y-20">
        <!-- v-html sits on a plain div: on a component it is skipped by SSR and never patched on hydration, so the boxes rendered empty -->
        <div v-if="hasRichTextContent(project.impact)">
            <CHeading :variant="3">Prečo túto aktivitu robíme?</CHeading>
            <CCardBox><div v-html="getRichTextContent(project.impact)" /></CCardBox>
        </div>

        <div v-if="hasRichTextContent(project.about)">
            <CHeading :variant="3">S čím potrebujeme pomôcť?</CHeading>
            <CCardBox><div v-html="getRichTextContent(project.about)" /></CCardBox>
        </div>

        <div v-if="hasRichTextContent(project.benefits)">
            <CHeading :variant="3">Čo dobrovoľníci/čky získajú?</CHeading>
            <CCardBox><div v-html="getRichTextContent(project.benefits)" /></CCardBox>
        </div>

        <div v-if="hasRichTextContent(project.progress)">
            <CHeading :variant="3">S akou podporou môžu dobrovoľníci počítať?</CHeading>
            <CCardBox><div v-html="getRichTextContent(project.progress)" /></CCardBox>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Project } from '#shared/types/Project'

defineProps<{
    project: Project
}>()

// The editor saves an emptied field as markup such as "<p></p>" or "<p>&nbsp;</p>",
// which is truthy, so check for visible text (or media) instead.
function hasRichTextContent(content: any): boolean {
    const html = getRichTextContent(content)
    if (/<(img|iframe|video)\b/i.test(html)) return true
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;/g, ' ').trim().length > 0
}

function getRichTextContent(content: any): string {
    if (!content) {
        return ''
    }

    if (typeof content === 'string') {
        return content
    }

    if (typeof content === 'object') {
        console.warn('Rich text content is an object:', content)
        if (content.text) {
            return content.text
        }
        if (content.html) {
            return content.html
        }
        return JSON.stringify(content)
    }

    return String(content)
}
</script>
